<head>
  <title>Admin Reports</title>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<app-breadcrumb></app-breadcrumb>
<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="row ps-0">
  <div class="col-md-6">
    <div
      *ngIf="qmsservice.adminReportFor=='User Password Changes' || qmsservice.adminReportFor=='User vs Functional Roles Privilege'">
      <div class="col-md-5" style="margin-left:10px;">
        <div>
          <label for="email" id="userName5"><b>User Name</b><span class="mandatory-symbol">*</span>: </label>
          <div style="display: flex; align-items: center;">
            <input type="text" class="form-control" style="padding: 6px 20px;" [disabled]="true"
              [(ngModel)]="oneQmsUsersFieldData.managerName" (ngModelChange)="onNgModelChange($event,'userName')"
              placeholder="Search">
            &nbsp; <span class="fa fa-search form-control-feedback" (click)="searchuserFunction();"
              (keydown.enter)="searchuserFunction();"></span>
          </div>&nbsp;&nbsp;
          <div class="col-sm-12 group-dropdown-align text-center">
            <div class="button-continer">
              <button mat-stroked-button class="addButton" (click)="genReport()">
                Generate
              </button>&nbsp;
              <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="qmsservice.adminReportFor=='Login Failed Attempts' ">
      <div>

        <div class="d-flex align-items-center col-md-12">
          <mat-radio-group [(ngModel)]="selectedOption" (change)="onRadioChange()">
            <mat-radio-button value="user">User</mat-radio-button>
            <mat-radio-button value="timeRange">Time Range</mat-radio-button>
          </mat-radio-group>
        </div>


        <div *ngIf="selectedOption === 'user'" class="col-md-5" style="margin-left:10px;">
          <div>
            <label for="email" id="userName1"><b>User Name</b><span class="mandatory-symbol">*</span>: </label>
          </div>
          <div style="display: flex; align-items: center;">
            <input type="text" class="form-control" style="padding: 6px 20px;" [disabled]="true"
              [(ngModel)]="oneQmsUsersFieldData.managerName" (ngModelChange)="onNgModelChange($event,'userName')"
              placeholder="Search">
            &nbsp;
            <span class="fa fa-search form-control-feedback" (click)="searchuserFunction();"
              (keydown.enter)="searchuserFunction();"></span>
          </div>
        </div>


        <div *ngIf="selectedOption === 'timeRange'" class="col-md-12" style="margin-left:10px;">
          <div class="row d-flex ">
            <div class=" col-md-6">
              <label for="customRange"><b>Custom Range</b>:</label>
              <mat-slide-toggle color="primary" [(ngModel)]="timeRangeToggle" (change)="timeRangeToggleFun($event)">
                <span class="active-inActive-container" *ngIf="timeRangeToggle" style="color: green;">Yes</span>
                <span *ngIf="!timeRangeToggle" style="color: red;">No</span>
              </mat-slide-toggle>
            </div>

            <div class="col-md-6" *ngIf="!timeRangeToggle">
              <div>
                <label for="timeRange" id="timeRangeLabel"
                  [ngClass]="{'error-label': showErrors && !selectedTimeRangeType, 'default-label': selectedTimeRangeType}">
                  <b>Time Range</b> <span class="mandatory-symbol">*</span> :
                </label>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="selectedTimeRangeType"
                (closed)="reportSearchText=''" (click)="focusSearch('focus-title-search')"
                (keydown.enter)="focusSearch('focus-title-search')">
                <input type="search" class="dropdownsearchstyle" [(ngModel)]="reportSearchText" matInput
                  placeholder="search" (ngModelChange)="onNgModelChange($event,'reportTypeLabel')">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
                <mat-option *ngFor="let item of timeListDropdown | assessmentSearch : reportSearchText;"
                  (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>
          </div>
          <div class="d-flex col-md-12 " *ngIf="timeRangeToggle" style="margin-top: 10px;">

            <div>
              <label [ngClass]="{'error-label': showErrors && !fromDate,'valid-label': !showErrors || fromDate }"
                id="fromDateAlert2" for="email"><b>From Date</b> <span class="mandatory-symbol">*</span>: </label>
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [maxDate]="maxDate"
                [(ngModel)]="fromDate" (ngModelChange)="onNgModelChange($event,'fromDateAlert2')">
            </div>&nbsp;&nbsp;&nbsp;&nbsp;
            <div>
              <label for="email"
                [ngClass]="{ 'error-label': showErrors && !toDate,  'valid-label': !showErrors || toDate }"><b>To
                  Date</b><span class="mandatory-symbol">*</span> : </label>
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [maxDate]="maxDate"
                [(ngModel)]="toDate" (ngModelChange)="onNgModelChange($event,'toDateAlert')">
            </div>
          </div>
        </div>
        &nbsp;&nbsp;&nbsp;&nbsp;

        <div class="col-sm-12 group-dropdown-align text-center">
          <div class="button-continer">
            <button mat-stroked-button class="addButton" (click)="genReport()">
              Generate
            </button>&nbsp;
            <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
              Reset
            </button>
          </div>
        </div>
      </div>

    </div>

    <div *ngIf="qmsservice.adminReportFor=='User Login' ">
      <div>

        <div class="d-flex align-items-center col-md-12">
          <mat-radio-group [(ngModel)]="selectedOption" (change)="onRadioChange()">
            <mat-radio-button value="user">User</mat-radio-button>
            <mat-radio-button value="timeRange">Time Range</mat-radio-button>
          </mat-radio-group>
        </div>


        <div *ngIf="selectedOption === 'user'" class="col-md-5" style="margin-left:10px;">
          <div>
            <label for="email" id="userName"><b>User Name</b><span class="mandatory-symbol">*</span>: </label>
          </div>
          <div style="display: flex; align-items: center;">
            <input type="text" class="form-control" style="padding: 6px 20px;" [disabled]="true"
              [(ngModel)]="oneQmsUsersFieldData.managerName" (ngModelChange)="onNgModelChange($event,'userName')"
              placeholder="Search">
            &nbsp;
            <span class="fa fa-search form-control-feedback" (click)="searchuserFunction();"
              (keydown.enter)="searchuserFunction();"></span>
          </div>
        </div>


        <div *ngIf="selectedOption === 'timeRange'" class="col-md-12" style="margin-left:10px;">
          <div class="row d-flex ">
            <div class=" col-md-6">
             <label for="customRange"><b>Custom Range</b>:</label>

              <mat-slide-toggle color="primary" [(ngModel)]="timeRangeToggle" (change)="timeRangeToggleFun($event)">
                <span class="active-inActive-container" *ngIf="timeRangeToggle" style="color: green;">Yes</span>
                <span *ngIf="!timeRangeToggle" style="color: red;">No</span>
              </mat-slide-toggle>
            </div>

            <div class="col-md-6" *ngIf="!timeRangeToggle">
              <div>
                <label for="timeRange" id="timeRangeLabel1"
                  [ngClass]="{'error-label': showErrors && !selectedTimeRangeType, 'default-label': selectedTimeRangeType}">
                  <b>Time Range</b> <span class="mandatory-symbol">*</span> :
                </label>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="selectedTimeRangeType"
                (closed)="reportSearchText=''" (click)="focusSearch('focus-title-search')"
                (keydown.enter)="focusSearch('focus-title-search')">
                <input type="search" class="dropdownsearchstyle" [(ngModel)]="reportSearchText" matInput
                  placeholder="search" (ngModelChange)="onNgModelChange($event,'reportTypeLabel')">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
                <mat-option *ngFor="let item of timeListDropdown | assessmentSearch : reportSearchText;"
                  (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>
          </div>
          <div class="d-flex col-md-12 " *ngIf="timeRangeToggle" style="margin-top: 10px;">

            <div>
              <label [ngClass]="{'error-label': showErrors && !fromDate,'valid-label': !showErrors || fromDate }"
                id="fromDateAlert1" for="email"><b>From Date</b> <span class="mandatory-symbol">*</span>: </label>
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="fromDate"
                [maxDate]="maxDate" (ngModelChange)="onNgModelChange($event,'fromDateAlert1')">
            </div>&nbsp;&nbsp;&nbsp;&nbsp;
            <div>
              <label for="email"
                [ngClass]="{ 'error-label': showErrors && !toDate,  'valid-label': !showErrors || toDate }"><b>To
                  Date</b><span class="mandatory-symbol">*</span> : </label>
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="toDate"
                [maxDate]="maxDate" (ngModelChange)="onNgModelChange($event,'toDateAlert')">
            </div>
          </div>
        </div>
        &nbsp;&nbsp;&nbsp;&nbsp;

        <div class="col-sm-12 group-dropdown-align text-center">
          <div class="button-continer">
            <button mat-stroked-button class="addButton" (click)="genReport()">
              Generate
            </button>&nbsp;
            <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
              Reset
            </button>
          </div>
        </div>
      </div>

    </div>

    <div *ngIf="qmsservice.adminReportFor=='User vs Activity' || qmsservice.adminReportFor=='User vs RM' ">
      <div class="col-md-5" style="margin-left:10px;">
        <div>
          <label for="email" id="userName2"><b>
              {{ qmsservice.adminReportFor === 'User vs RM' ? 'Manager Name' : 'User Name' }}</b><span
              class="mandatory-symbol">*</span>: </label>
        </div>
        <div style="display: flex; align-items: center;">
          <input type="text" class="form-control" style="padding: 6px 20px;" [disabled]="true" [(ngModel)]="managerName"
            (ngModelChange)="onNgModelChange($event,'userName')" placeholder="Search">
          &nbsp; <span class="fa fa-search form-control-feedback" (click)="searchManagerFunction();"
            (keydown.enter)="searchManagerFunction();"></span>
        </div>
      </div>&nbsp;&nbsp;
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="qmsservice.adminReportFor=='QMS User Group'">
      <div class="row">
        <div class="col-md-5">
          <div><label for="email" id="groupNameAlert"><b>Group</b> <span class="mandatory-symbol">*</span> : </label>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedGroupValue" (closed)="groupSearchText=''"
            (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-group-search')">
            <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput
              placeholder="search">
            <mat-option [value]="null" class="unselectStyle"
              (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of groupValueDropdown | assessmentSearch : groupSearchText"
              (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-5">
          <div><label for="email"> <b> Module</b></label></div>
          <mat-select matInput placeholder="Select" [(ngModel)]="reportModuleValue" (closed)="groupSearchText=''"
            (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-group-search')">
            <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput
              placeholder="search">
            <mat-option [value]="null" class="unselectStyle"
              (onSelectionChange)="onModuleSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of moduleListDropdown | assessmentSearch : groupSearchText"
              (onSelectionChange)="onModuleSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-5" style="margin-left:10px;">
          <div><label for="email" id="userName3"><b> User Name</b>: </label></div>
          <div style="display: flex; align-items: center;">
            <input type="text" class="form-control" style="padding: 6px 20px;" [disabled]="true"
              [(ngModel)]="managerName" (ngModelChange)="onNgModelChange($event,'userName3')" placeholder="Search">
            &nbsp; <span class="fa fa-search form-control-feedback" (click)="searchManagerFunction();"
              (keydown.enter)="searchManagerFunction();"></span>
          </div>
        </div>
      </div><br>
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="qmsservice.adminReportFor=='TMS User Group'">
      <div class="row">
        <div class="col-md-5">
          <div><label for="email" id="groupNameAlert2"><b>Group</b> <span class="mandatory-symbol">*</span> : </label>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedGroupValue" (closed)="groupSearchText=''"
            (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-group-search')">
            <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput
              placeholder="search">
            <mat-option [value]="null" class="unselectStyle"
              (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of groupValueDropdownTms | assessmentSearch : groupSearchText"
              (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-5">
          <div style=" justify-content: center;">
            <label for="email" id="trainingNameAlert"><b>Training Name </b> :</label>&nbsp;
            <div style="display: flex; align-items: center;">
              <input id="participantUserName" style="padding: 6px 20px;" type="text" class="form-control"
                [(ngModel)]="getSelectedTrainingName" [disabled]="true" placeholder="Search">&nbsp;&nbsp;
              <span class="fa fa-search form-control-feedback" (click)="searchTrainingFunction();"
                (keydown.enter)="searchTrainingFunction();"></span>
            </div>
          </div>
        </div>
        <div class="col-md-5" style="margin-left:10px;">
          <div><label for="email" id="userName4"><b> User Name</b>: </label></div>
          <div style="display: flex; align-items: center;">
            <input type="text" class="form-control" style="padding: 6px 20px;" [disabled]="true"
              [(ngModel)]="managerName" (ngModelChange)="onNgModelChange($event,'userName4')" placeholder="Search">
            &nbsp; <span class="fa fa-search form-control-feedback" (click)="searchManagerFunction();"
              (keydown.enter)="searchManagerFunction();"></span>
          </div>
        </div>
      </div>&nbsp;&nbsp;
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
    </div>


    <div *ngIf=" qmsservice.adminReportFor=='DMS User Group' ">
      <div class="row">
        <div class="col-md-5">
          <div><label for="email" id="groupNameAlert1"><b>Group</b> <span class="mandatory-symbol">*</span> : </label>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedGroupValue" (closed)="groupSearchText=''"
            (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-group-search')">
            <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput
              placeholder="search">
            <mat-option [value]="null" class="unselectStyle"
              (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of groupValueDropdownDms | assessmentSearch : groupSearchText"
              (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-5">
          <div><label for="email">Folder</label></div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              [(ngModel)]="dmsGroupFoldersFieldData.folderName"
              [disabled]="visibleDmsGroupFoldersReasonForUpdateField === true" (click)="searchDocumentFunction()">
          </div>
        </div>
      </div>
      &nbsp;&nbsp;
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
      <div>
      </div>
    </div>

    <div *ngIf="qmsservice.adminReportFor=='Switch User Log'">
      <div class="row">
        <div class="col-md-5">
          <div>
            <label for="reportType" id="reportTypeLabel"
              [ngClass]="{'error-label': showErrors && !selectedReportType, 'default-label': !showErrors || selectedReportType}">
              <b>Report Type</b> <span class="mandatory-symbol">*</span> :
            </label>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportType" (closed)="reportSearchText=''"
            (click)="focusSearch('focus-title-search')" (keydown.enter)="focusSearch('focus-title-search')">
            <input type="search" class="dropdownsearchstyle" [(ngModel)]="reportSearchText" matInput
              placeholder="search" (ngModelChange)="onNgModelChange($event,'reportTypeLabel')">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onReportTypeSelectnew($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of reportListDropdown | assessmentSearch : reportSearchText;"
              (onSelectionChange)="onReportTypeSelectnew($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-5" *ngIf="selectedReportType === 'qualityIssue' || selectedReportType === 'training'">
          <div>
            <label for="subReportType" id="moduleTypeLabel" [ngClass]="{
                     'error-label': showErrors && (selectedReportType === 'qualityIssue' || selectedReportType === 'training') && !selectedModuleType, 
                     'default-label': !showErrors || selectedModuleType
                   }">
              <b>Module</b><span class="mandatory-symbol">*</span> :
            </label>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedModuleType" (closed)="moduleSearchText=''"
            (click)="focusSearch('focus-title-search')" (keydown.enter)="focusSearch('focus-title-search')">
            <input type="search" class="dropdownsearchstyle" [(ngModel)]="moduleSearchText" matInput
              placeholder="search" (ngModelChange)="onNgModelChange($event,'manageReportNameAlert')">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onModuleSelectNew($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of moduleDropdownList | assessmentSearch : moduleSearchText"
              (onSelectionChange)="onModuleSelectNew($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>



        <div class="col-md-5" *ngIf="selectedReportType === 'qualityIssue'">
          <div><label for="email"><b>Group</b> : </label>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedGroupValue" (closed)="groupSearchText=''"
            (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-group-search')">
            <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput
              placeholder="search">
            <mat-option [value]="null" class="unselectStyle"
              (onSelectionChange)="onGroupValueSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of groupValueDropdown | assessmentSearch : groupSearchText"
              (onSelectionChange)="onGroupValueSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-md-5" *ngIf="selectedReportType !== 'FORMS'">
          <div>
            <label for="subReportType" id="subReportTypeLabel"><b>Refernce Number</b> :</label>
          </div>
          <div style="display: flex; align-items: center;">
            <input type="text" class="form-control" style="padding: 6px 20px;" [disabled]="true"
              [(ngModel)]="getSelectedTaskId" (ngModelChange)="onNgModelChange($event,'userName')" placeholder="Search">
            &nbsp; <span class="fa fa-search form-control-feedback" (click)="searchModuleIDFunction();"
              (keydown.enter)="searchModuleIDFunction();"></span>
          </div>

        </div>
        <div class="col-md-5" *ngIf="selectedReportType === 'FORMS'">
          <div>
            <label for="subReportType" id="subReportTypeLabel1"><b>Refernce Number</b> :</label>
          </div>
          <div style="display: flex; align-items: center;">
            <input type="text" class="form-control" style="padding: 6px 20px;" [(ngModel)]="getSelectedTaskNo"
              (ngModelChange)="onNgModelChange($event,'userName')" placeholder="Refernce Number">

          </div>

        </div>


      </div>&nbsp;&nbsp;
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>


  <div class="col-md-6">
    <div class="row">
      <div class="col-md-4">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.adminReportFor  === 'Default'}"
          (click)="moreAdminReportDetails('Default')" (keydown.enter)="moreAdminReportDetails('Default')">
          <div class="reports_block">
            <img src="../../assets/img/DMS/circle.png" width="16px" height="16px" alt="Default">
          </div>
          <p class="report_subtext">Default</p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="d-flex gap-2 align-items-center  report"
          [ngClass]="{'active':this.qmsservice.adminReportFor  === 'Login Failed Attempts'}"
          (click)="moreAdminReportDetails('Login Failed Attempts')"
          (keydown.enter)="moreAdminReportDetails('Login Failed Attempts')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/user (3).png" width="16px" height="16px" alt="Login Failed Attempts">
          </div>
          <p class="report_subtext">Login Failed Attempts</p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.adminReportFor  === 'User Password Changes'}"
          (click)="moreAdminReportDetails('User Password Changes')"
          (keydown.enter)="moreAdminReportDetails('User Password Changes')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/reset-password (1).png" width="16px" height="16px" alt="User Password Changes">
          </div>
          <p class="report_subtext">User Password Changes</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.adminReportFor  === 'User vs Functional Roles Privilege'}"
          (click)="moreAdminReportDetails('User vs Functional Roles Privilege')"
          (keydown.enter)="moreAdminReportDetails('User vs Functional Roles Privilege')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/functions.png" width="16px" height="16px"
              alt="User vs Functional Roles Privilege">
          </div>
          <p class="report_subtext">User vs Functional Roles Privilege</p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.adminReportFor  === 'User vs RM'}"
          (click)="moreAdminReportDetails('User vs RM')" (keydown.enter)="moreAdminReportDetails('User vs RM')"
          style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/versus (1).png" width="16px" height="16px" alt="User vs RM">
          </div>
          <p class="report_subtext">User vs RM</p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.adminReportFor  === 'User vs Activity'}"
          (click)="moreAdminReportDetails('User vs Activity')"
          (keydown.enter)="moreAdminReportDetails('User vs Activity')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/DMS/effectiveness_check.svg" width="16px" height="16px" alt="User vs Activity">
          </div>
          <p class="report_subtext">User vs Activity</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4" *ngIf="isQMS">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.adminReportFor  === 'QMS User Group'}"
          (click)="moreAdminReportDetails('QMS User Group')" (keydown.enter)="moreAdminReportDetails('QMS User Group')"
          style=" cursor: pointer;">
          <div class="reports_block">
            <i class="fa-solid fa-certificate" style="color: #fbfcfe;"></i>
          </div>
          <p class="report_subtext">QMS User Group</p>
        </div>
      </div>
      <div class="col-md-4" *ngIf="!isQMS"></div>

      <div class="col-md-4" *ngIf="isTRN">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.adminReportFor  === 'TMS User Group'}"
          (click)="moreAdminReportDetails('TMS User Group')" (keydown.enter)="moreAdminReportDetails('TMS User Group')"
          style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/user (4).png" width="16px" height="16px" alt="TMS User Group">
          </div>
          <p class="report_subtext">TMS User Group</p>
        </div>
      </div>
      <div class="col-md-4" *ngIf="!isTRN"></div>

      <div class="col-md-4" *ngIf="isDMS">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.adminReportFor  === 'DMS User Group'}"
          (click)="moreAdminReportDetails('DMS User Group')" (keydown.enter)="moreAdminReportDetails('DMS User Group')"
          style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/folder (3).png" width="16px" height="16px" alt="DMS User Group">
          </div>
          <p class="report_subtext">DMS User Group</p>
        </div>
      </div>
      <div class="col-md-4" *ngIf="!isDMS"></div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="d-flex gap-2 align-items-center report"
          [ngClass]="{'active':this.qmsservice.adminReportFor  === 'Switch User Log'}"
          (click)="moreAdminReportDetails('Switch User Log')"
          (keydown.enter)="moreAdminReportDetails('Switch User Log')" style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/switchReport.png" width="16px" height="16px" alt="Switch User Log">
          </div>
          <p class="report_subtext">Switch User Log</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="d-flex gap-2 align-items-center  report"
          [ngClass]="{'active':this.qmsservice.adminReportFor  === 'User Login'}"
          (click)="moreAdminReportDetails('User Login')" (keydown.enter)="moreAdminReportDetails('User Login')"
          style=" cursor: pointer;">
          <div class="reports_block">
            <img src="../../assets/img/user (3).png" width="16px" height="16px" alt="User Login">
          </div>
          <p class="report_subtext">User Login</p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="d-flex gap-2 align-items-center  report">
          <div class="">

          </div>
          <p class="report_subtext"></p>
        </div>
      </div>
    </div>
  </div>
</div>
<hr>
<div class="table-container" *ngIf="qmsservice.adminReportFor=='Login Failed Attempts' && showNoRecordFoundLoginFailed">
  <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
    <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
</div>
<div class="table-container"
  *ngIf=" qmsservice.adminReportFor=='Login Failed Attempts'&& tableReportUserLoginFailedDataList && tableReportUserLoginFailedDataList.length > 0 ">
  <div class="menu-container">
    <div class="row menu-row-container">
      <div class="col-sm-6 gridName-container">
        <span class="gridName">{{qmsservice.adminReportFor}}</span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-8"></div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
      <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">Excel Report</span>
    </div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
      <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">PDF Report</span>
    </div>
  </div>&nbsp;&nbsp;
  <div class="table-container">
    <table style="height: 60vh;">
      <thead>
        <th>
          <span>User Name</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('userName', $event,'s')" />
          </div>
        </th>
        <th>
          <span>User Full Name</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('userFullname', $event,'s')" />
          </div>
        </th>
        <th>
          <span>Logged Attempted On</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('loggedAttemptedOnStr', $event,'d')" />
          </div>
        </th>
        <th>
          <span> Attempt </span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('attempt', $event,'n')" />
          </div>
        </th>

        <th>
          <span>Is Locked</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('isLocked', $event,'s')" />
          </div>
        </th>
        <th class="sticky-col first-col"></th>
      </thead>
      <tr *ngIf="pagedItems1.length === 0">
        <td class="row-data text-center" colspan="15">No records found</td>
      </tr>
      <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems1; let idx = index;">
        <td class="row-data">{{ listOfUsersData.userName }}</td>
        <td class="row-data">{{ listOfUsersData.userFullname }}</td>
        <td class="row-data">{{ listOfUsersData.loggedAttemptedOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.attempt }}</td>

        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isLocked === 'Y'" src="../../assets/img/accessSymbol.svg" width="20" height="20"
              alt="Access granted symbol">
            <img *ngIf="listOfUsersData.isLocked === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
          </div>
        </td>
      </tr>
    </table>
  </div>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text"  ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>
</div>

<div class="table-container"
  *ngIf=" qmsservice.adminReportFor=='User Login'&& tableReportUserLoginFailedDataList && tableReportUserLoginFailedDataList.length > 0 ">
  <div class="menu-container">
    <div class="row menu-row-container">
      <div class="col-sm-6 gridName-container">
        <span class="gridName">{{qmsservice.adminReportFor}}</span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-8"></div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
      <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">Excel Report</span>
    </div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
      <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">PDF Report</span>
    </div>
  </div>&nbsp;&nbsp;
  <div class="table-container">
    <table style="height: 60vh;">
      <thead>
        <th>
          <span>User Name</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('userName', $event,'s')" />
          </div>
        </th>


        <th>
          <span>Logged On</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('loggedOnStr', $event,'d')" />
          </div>
        </th>

        <th>
          <span>Logged Out</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('loggedOutStr', $event,'d')" />
          </div>
        </th>
        <th class="sticky-col first-col"></th>
      </thead>
      <tr *ngIf="pagedItems1.length === 0">
        <td class="row-data text-center" colspan="15">No records found</td>
      </tr>
      <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems1; let idx = index;">
        <td class="row-data">{{ listOfUsersData.userName }}</td>

        <td class="row-data">{{ listOfUsersData.loggedOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.loggedOutStr }}</td>

        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isLocked === 'Y'" src="../../assets/img/accessSymbol.svg" width="20" height="20"
              alt="Access granted symbol">
            <img *ngIf="listOfUsersData.isLocked === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
          </div>
        </td>
      </tr>
    </table>
  </div>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>
</div>
<div class="table-container"
  *ngIf="qmsservice.adminReportFor=='User Password Changes' && showNoRecordFounduserPassword">
  <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
    <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
</div>
<div class="table-container"
  *ngIf="qmsservice.adminReportFor=='User Password Changes' && tableReportUserPasswordChangesDataList && tableReportUserPasswordChangesDataList.length > 0">
  <div class="menu-container">
    <div class="row menu-row-container">
      <div class="col-sm-6 gridName-container">
        <span class="gridName">{{qmsservice.adminReportFor}}</span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-8"></div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
      <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">Excel Report</span>
    </div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
      <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">PDF Report</span>
    </div>
  </div>&nbsp;&nbsp;
  <div class="table-container">
    <table style="height: 60vh;">
      <thead>
        <th>
          <span>User Name</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter5('userName', $event,'s')" />
          </div>
        </th>
        <th>
          <span>User Full Name</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter5('userFullname', $event,'s')" />
          </div>
        </th>
        <th>
          <span>Password Changed On</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter5('passwordChangedOnStr', $event,'d')" />
          </div>
        </th>
        <th>
          <span>Next Password Reset On</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter5('nextPasswordResetOnStr', $event,'d')" />
          </div>
        </th>
      </thead>  
      <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems2; let idx = index;">
        <td class="row-data">{{ listOfUsersData.userName}}</td>
        <td class="row-data">{{ listOfUsersData.userFullname}}</td>
        <td class="row-data">{{ listOfUsersData.passwordChangedOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.nextPasswordResetOnStr}}</td>
      </tr>
    </table>
  </div>
  <div class="row border-top mt-1 width-cheat small paginationCell">
    <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
    </nav>
    <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
      {{ showingRowsText }}
      1-{{ perPage }} of {{ collectionSize | number }}
      <ngb-pagination class="leftpadding" (pageChange)="setPage2(pager.currentPage,$event)" [disabled]="false"
        [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
        [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
      </ngb-pagination>
      <div ngbDropdown class="d-inline-block leftpadding">
        <button class="btn btn-primary btn-sm mr-1 " id="dropdownBasic2" ngbDropdownToggle>
          {{perPage}}
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
          <button ngbDropdownItem (click)="paginationCall2(10)">10</button>
          <button ngbDropdownItem (click)="paginationCall2(20)">20</button>
          <button ngbDropdownItem (click)="paginationCall2(50)">50</button>
        </div>
        per page
      </div>
    </nav>
    <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
    </div>
  </div>
</div>
<div class="table-container"
  *ngIf="qmsservice.adminReportFor=='Concurrent users / Active login sessions' || qmsservice.adminReportFor=='User vs RM'">
  <div class="table-container" *ngIf="showNoRecordFoundConcurrent || showNoRecordFoundUserVsRm">
    <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
      <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
  </div>
  <div
    *ngIf="!showNoRecordFoundConcurrent && !showNoRecordFoundUserVsRm && tableReportUserActiveUserDataList && tableReportUserActiveUserDataList.length > 0">
    <div class="menu-container">
      <div class="row menu-row-container">
        <div class="col-sm-6 gridName-container">
          <span class="gridName">{{qmsservice.adminReportFor}}</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>&nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead>
          <th>
            <span>User Name</span>
            <span class="fa-solid fa-filter"></span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('userName', $event,'s')" />
            </div>
          </th>
          <th>
            <span>User Full Name</span>
            <span class="fa-solid fa-filter"></span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('userFullname', $event,'s')" />
            </div>
          </th>
          <th>
            <span>Is AD User</span>
            <span class="fa-solid fa-filter"></span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('isAdUser', $event,'s')" />
            </div>
          </th>
          <th>
            <span>User Description</span>
            <span class="fa-solid fa-filter"></span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('userDescription', $event,'s')" />
            </div>
          </th>
          <th>
            <span>Designation</span>
            <span class="fa-solid fa-filter"></span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('designation', $event,'s')" />
            </div>
          </th>
          <th>
            <span>Department</span>
            <span class="fa-solid fa-filter"></span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('department', $event,'s')" />
            </div>
          </th>
          <th>
            <span>Manager Name</span>
            <span class="fa-solid fa-filter"></span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('managerName', $event,'s')" />
            </div>
          </th>
          <th>
            <span>Email Address</span>
            <span class="fa-solid fa-filter"></span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('emailAddress', $event,'s')" />
            </div>
          </th>
          <th>
            <span>Contact Number</span>
            <span class="fa-solid fa-filter"></span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('contactNumber', $event,'s')" />
            </div>
          </th>
          <th>
            <span>Country</span>
            <span class="fa-solid fa-filter"></span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('country', $event,'s')" />
            </div>
          </th>
          <th>
            <span>City</span>
            <span class="fa-solid fa-filter"></span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter6('city', $event,'s')" />
            </div>
          </th>
          <th>
            <span>Time Zone</span>
            <span class="fa-solid fa-filter"></span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('timezone', $event,'s')" />
            </div>
          </th>

          <th>
            <span>Is Active</span>
            <span class="fa-solid fa-filter"></span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('isActive', $event,'s')" />
            </div>
          </th>
          <th>
            <span>Created On</span>
            <span class="fa-solid fa-filter"></span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search" (input)="applyFilter6('city', $event,'s')" />
            </div>
          </th>
          <th>
            <span>Updated On</span>
            <span class="fa-solid fa-filter"></span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('isActive', $event,'s')" />
            </div>
          </th>
          <th>
            <span>Created By</span>
            <span class="fa-solid fa-filter"></span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('country', $event,'s')" />
            </div>
          </th>
          <th>
            <span>Updated By</span>
            <span class="fa-solid fa-filter"></span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter6('timezone', $event,'s')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>
        <tr *ngIf="pagedItems3.length === 0">
          <td class="row-data text-center" colspan="15">No records found</td>
        </tr>
        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems3; let idx = index;">
          <td class="row-data">{{ listOfUsersData.userName }}</td>
          <td class="row-data">{{ listOfUsersData.userFullName }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isAdUser === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isAdUser === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.userDescription }}</td>
          <td class="row-data">{{ listOfUsersData.designation }}</td>
          <td class="row-data">{{ listOfUsersData.department }}</td>
          <td class="row-data">{{ listOfUsersData.managerName }}</td>
          <td class="row-data">{{ listOfUsersData.emailAddress }}</td>
          <td class="row-data">{{ listOfUsersData.contactNumber }}</td>
          <td class="row-data">{{ listOfUsersData.country }}</td>
          <td class="row-data">{{ listOfUsersData.city }}</td>
          <td class="row-data">{{ listOfUsersData.timezone }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isActive === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isActive === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>

          <td class="row-data">{{ listOfUsersData.createdOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.updatedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
          <td class="row-data">{{ listOfUsersData.updatedByUser }}</td>

        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" "></nav>

      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage3(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " id="dropdownBasic3" ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic3">
            <button ngbDropdownItem (click)="paginationCall3(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall3(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall3(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
</div>
<div class="table-container" *ngIf="qmsservice.adminReportFor=='User vs Activity' && showNoRecordFoundUserVsActivity">
  <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
    <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
</div>
<div class="table-container"
  *ngIf="qmsservice.adminReportFor=='User vs Activity' && !showNoRecordFoundUserVsActivity && tableReportUserActivityMappingDataList && tableReportUserActivityMappingDataList.length > 0">
  <div class="menu-container">
    <div class="row menu-row-container">
      <div class="col-sm-6 gridName-container">
        <span class="gridName">{{qmsservice.adminReportFor}}</span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-8"></div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
      <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">Excel Report</span>
    </div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
      <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">PDF Report</span>
    </div>
  </div>&nbsp;&nbsp;
  <div class="table-container">
    <table style="height: 60vh;">
      <thead>
        <th>
          <span>Module Code</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter7('moduleCode', $event,'s')" />
          </div>
        </th>

        <th>
          <span>Version</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter7('version', $event,'s')" />
          </div>
        </th>
        <th>
          <span>Task Name</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter7('taskName', $event,'s')" />
          </div>
        </th>
        <th>
          <span>Sub Task Name</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter7('subTaskName', $event,'s')" />
          </div>
        </th>
        <th>
          <span>Sub Module Name</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter7('subModuleName', $event,'s')" />
          </div>
        </th>
        <th>
          <span>Status</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search" (input)="applyFilter7('status', $event,'s')" />
          </div>
        </th>
        <th>
          <span>Other Details</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter7('otherDetails', $event,'s')" />
          </div>
        </th>
        <th>
          <span>Task Owner User Name</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter7('taskOwnerUserName', $event,'s')" />
          </div>
        </th>
        <th>
          <span>Requester User Name</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter7('requesterUserName', $event,'s')" />
          </div>
        </th>
        <th>
          <span>Action Requested On</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter7('actionRequestedOn', $event,'d')" />
          </div>
        </th>
        <th>
          <span>Pending With User Names</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter7('pendingWithUserNames', $event,'s')" />
          </div>
        </th>
        <th>
          <span>Due On</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search" (input)="applyFilter7('dueOn', $event,'s')" />
          </div>
        </th>
        <th class="sticky-col first-col"></th>
      </thead>
      <tr *ngIf="pagedItems4.length === 0">
        <td class="row-data text-center" colspan="15">No records found</td>
      </tr>
      <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems4; let idx = index;">
        <td class="row-data">{{ listOfUsersData.moduleCode }}</td>
        <td class="row-data">{{ listOfUsersData.version ? (listOfUsersData.version | number:'1.2-2') : '' }} </td>
        <td class="row-data">{{ listOfUsersData.taskName }}</td>
        <td class="row-data">{{ listOfUsersData.subTaskName }}</td>
        <td class="row-data">{{ listOfUsersData.subModuleName }}</td>
        <td class="row-data">{{ listOfUsersData.status }}</td>
        <td class="row-data">{{ listOfUsersData.otherDetails }}</td>
        <td class="row-data">{{ listOfUsersData.taskOwnerUserName }}</td>
        <td class="row-data">{{ listOfUsersData.requesterUserName }}</td>
        <td class="row-data">{{ listOfUsersData.actionRequestedOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.pendingWithUserNames }}</td>
        <td class="row-data">{{ listOfUsersData.dueOnStr}}</td>
      </tr>
    </table>
  </div>
  <div class="row border-top mt-1 width-cheat small paginationCell">
    <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
    </nav>
    <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
      {{ showingRowsText }}
      1-{{ perPage }} of {{ collectionSize | number }}
      <ngb-pagination class="leftpadding" (pageChange)="setPage4(pager.currentPage,$event)" [disabled]="false"
        [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
        [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
      </ngb-pagination>
      <div ngbDropdown class="d-inline-block leftpadding">
        <button class="btn btn-primary btn-sm mr-1 " id="dropdownBasic4" ngbDropdownToggle>
          {{perPage}}
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic4">
          <button ngbDropdownItem (click)="paginationCall4(10)">10</button>
          <button ngbDropdownItem (click)="paginationCall4(20)">20</button>
          <button ngbDropdownItem (click)="paginationCall4(50)">50</button>
        </div>
        per page
      </div>
    </nav>
    <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
    </div>
  </div>
</div>



<div class="table-container" *ngIf="qmsservice.adminReportFor=='Switch User Log' && showNoRecordFoundSwitchUserLog">
  <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
    <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
</div>
<div class="table-container"
  *ngIf="qmsservice.adminReportFor=='Switch User Log' &&  !showNoRecordFoundSwitchUserLog && getOneQmsSwitchUserLogVw && getOneQmsSwitchUserLogVw.length > 0 ">
  <div class="menu-container">
    <div class="row menu-row-container">
      <div class="col-sm-6 gridName-container">
        <span class="gridName">{{qmsservice.adminReportFor}}</span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-8"></div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
      <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">Excel Report</span>
    </div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
      <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">PDF Report</span>
    </div>
  </div>&nbsp;&nbsp;
  <div class="table-container">
    <table style="height: 60vh;">
      <thead>
        <th>
          <span>Task Id</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search" (input)="applyFilter2('taskId', $event,'s')" />
          </div>
        </th>

        <th>
          <span>Task Details</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter2('taskDetails', $event,'s')" />
          </div>
        </th>
        <th>
          <span>Switched By User</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter2('switchedByUser', $event,'s')" />
          </div>
        </th>
        <th>
          <span>Switched From User</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter2('switchedFromUser', $event,'s')" />
          </div>
        </th>
        <th>
          <span>Switched To User</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter2('switchedToUser', $event,'s')" />
          </div>
        </th>
        <th>
          <span>Status</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search" (input)="applyFilter2('status', $event,'s')" />
          </div>
        </th>
        <th>
          <span>Switched At</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter2('switchedAt', $event,'s')" />
          </div>
        </th>
        <th>
          <span>Created On</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter2('createdOnStr', $event,'s')" />
          </div>
        </th>
      
        <th>
          <span>Module Name</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter2('moduleFullName', $event,'d')" />
          </div>
        </th>
        <th>
          <span>Owner Name</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter2('ownerName', $event,'s')" />
          </div>
        </th>
        <th>
          <span>User Role</span>
          <span class="fa-solid fa-filter"></span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter2('userRole', $event,'s')" />
          </div>
        </th>
        <th class="sticky-col first-col"></th>
      </thead>
      
      <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems5; let idx = index;">
        <td class="row-data">{{ listOfUsersData.taskId }}</td>
        <td class="row-data">{{ listOfUsersData.taskDetails }}</td>
        <td class="row-data">{{ listOfUsersData.switchedByUser }}</td>
        <td class="row-data">{{ listOfUsersData.switchedFromUser }}</td>
        <td class="row-data">{{ listOfUsersData.switchedToUser }}</td>
        <td class="row-data">{{ listOfUsersData.status }}</td>
        <td class="row-data">{{ listOfUsersData.switchedAt }}</td>
        <td class="row-data">{{ listOfUsersData.createdOnStr }}</td>
        
        <td class="row-data">{{ listOfUsersData.moduleFullName}}</td>
        <td class="row-data">{{ listOfUsersData.ownerName }}</td>
        <td class="row-data">{{ listOfUsersData.userRole}}</td>
      </tr>
    </table>
  </div>
  <div class="row border-top mt-1 width-cheat small paginationCell">
    <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
    </nav>
    <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
      {{ showingRowsText }}
      1-{{ perPage }} of {{ collectionSize | number }}
      <ngb-pagination class="leftpadding" (pageChange)="setPage5(pager.currentPage,$event)" [disabled]="false"
        [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
        [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
      </ngb-pagination>
      <div ngbDropdown class="d-inline-block leftpadding">
        <button class="btn btn-primary btn-sm mr-1 " id="dropdownBasic5" ngbDropdownToggle>
          {{perPage}}
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic5">
          <button ngbDropdownItem (click)="paginationCall5(10)">10</button>
          <button ngbDropdownItem (click)="paginationCall5(20)">20</button>
          <button ngbDropdownItem (click)="paginationCall5(50)">50</button>
        </div>
        per page
      </div>
    </nav>
    <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
    </div>
  </div>
</div>
<div
  *ngIf="showNoRecordFoundimg && (qmsservice.adminReportFor=='User vs Functional Roles Privilege' || qmsservice.adminReportFor=='QMS User Group' || qmsservice.adminReportFor=='DMS User Group' || qmsservice.adminReportFor=='TMS User Group')">
  <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
    <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 300px; height: 200px;"></span>
</div>
<div
  *ngIf=" tmsUserTrainingsRepVwDataForGrid.length>0 && (qmsservice.adminReportFor=='User vs Functional Roles Privilege' || qmsservice.adminReportFor=='QMS User Group' || qmsservice.adminReportFor=='DMS User Group' || qmsservice.adminReportFor=='TMS User Group')">
  <!--Details grid -->
  <div class="row">
    <div class="menu-container">
      <div class="row menu-row-container">
        <div class="col-sm-6 ">
          <span class="gridName">{{qmsservice.adminReportFor}}</span>
        </div>
        <div class="col-sm-1">
          <div class="reloadIconContiner" (click)="refreshGridData()" (keydown.enter)="refreshGridData()">
            <i class="fas fa-redo-alt" matTooltip="Refresh Grid"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="table-container">
      <div class="row">
        <div class="col-6"></div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center col-2"
          *ngIf="message.dataGridAdmin" (click)="openReorder()" (keydown.enter)="openReorder()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
            <path style="fill:'#FFFFFF'"
              d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
          </svg>
          <span class="reload_text text-white">Settings</span>
        </div>
        <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
          <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Excel Report</span>
        </div>
        <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
          <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">PDF Report</span>
        </div>
      </div>&nbsp;&nbsp;
      <div class="table-container">
        <table style="height: 60vh;">
          <thead>
            <th style="min-width: 60px; text-align: center;"
              [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
            </th>
            <th id="grid-header-container"
              *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;"
              [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width}"
              class="sticky-dynamic-col1 dynamic-table-header-style">
              <div>
                <span>{{oneQmsUsersDataForTable1Data.fieldColumnarray}}</span>
                <div class="row-search-container">
                  <input type="text" class="form-control" placeholder="Search"
                    (input)="applyFilter33(columnLists.columnsListarray[ix],$event)">
                </div>
              </div>
            </th>
          </thead>
          <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;">
            <td style="min-width: 60px; text-align: center;"
              [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
              <div style="display: flex;">
                <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </div>
                <div>
                  <input type="checkbox" style="zoom: 1.2;" [checked]="childCheckBoxs"
                    (change)="dataGridChildCheckBoxChecked($event, list, idx)">
                </div>
              </div>
            </td>
            <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
              class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden',
          'text-overflow': 'ellipsis',
          'white-space': 'nowrap'}">
              <span *ngIf="key.dataType=='CHECKBOX'">
                <div class="gridCheckBoxes">
                  <img *ngIf="list[key.columnsListarray]" alt=" " src="../../assets/img/accessSymbol.svg" width="20"
                    height="20">
                  <img *ngIf="list[key.columnsListarray]==false" alt=" " src="../../assets/img/noAcessSymbol.svg"
                    width="20" height="20">
                </div>
              </span>
              <span *ngIf="list[key.columnsListarray]=='htmlClobView' || list[key.columnsListarray]=='htmlClobView'">
                <div class="download-button-continer btn-align" mat-dialog-actions>
                  <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                    (click)="getClobData(list,key.columnsListarray)">
                    <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
                    <span class="ms-1">View</span>
                  </button>
                </div>
              </span>
              <span *ngIf="key.columnsListarray=='QMS_ROLES'" title="{{ list[key.columnsListarray] }}">
                {{ list[key.columnsListarray] }}</span>
              <span
                *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa' ">{{
                list[key.columnsListarray]}}</span>
              <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
            </td>
          </tr>
        </table>
      </div>
      <div class="row border-top mt-1 width-cheat small paginationCell">
        <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
        </nav>
        <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
          <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage,$event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
          <div ngbDropdown class="d-inline-block leftpadding">
            <button class="btn btn-primary btn-sm mr-1 " id="dropdownBasic" ngbDropdownToggle>
              {{perPage}}
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic">
              <button ngbDropdownItem (click)="paginationCall(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall(50)">50</button>
            </div>
            per page
          </div>
        </nav>
        <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #searchTraining>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchTrainingFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div  class="form-continer">
    <div class="row">
      <label for=" " style="color:red;" *ngIf="noUserAlert">Please select training</label>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div><label for="email">Training Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Training Name"
          [(ngModel)]="searchByTrainingName">
        <div id="firstName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Training Code</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Training Code"
          [(ngModel)]="searchByTrainingCode">
        <div id="lastName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Category</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByCategory" (closed)="categorySearchText=''"
          (click)="focusSearch('focus-title-search')" (keydown.enter)="focusSearch('focus-title-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="categorySearchText" matInput
            placeholder="search">
          <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
          <mat-option *ngFor="let item of categoryDropdown | assessmentSearch : categorySearchText;"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email">Language</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByLanguage" (closed)="languageSearchText=''"
          (click)="focusSearch('focus-title-search')" (keydown.enter)="focusSearch('focus-title-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="languageSearchText" matInput
            placeholder="search">
          <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
          <mat-option *ngFor="let item of languageDropdown | assessmentSearch : languageSearchText;"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row">
      <div class="search-button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="searchButton" (click)="searchTrainingGridDataFunction()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetSearchTrainingGridDataFunction()">
          <i class="fa fa-repeat"></i> Reset
        </button>
      </div>
    </div>
    <div class="table-container" *ngIf="showUserSearchGrid">
      <table class="search-manager-table-container">
        <th style="min-width: 80px; text-align: center;">
          <div style="display: flex;">
          </div>
        </th>
        <th> <span>Training Name</span> <span class="fa-solid fa-filter"></span>
        </th>
        <th> <span>Training Code</span> <span class="fa-solid fa-filter"></span>
        </th>
        <th> <span>Version</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Category</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Training Type</span> <span class="fa-solid fa-filter"></span>
        </th>
        <th> <span>Language</span> <span class="fa-solid fa-filter"></span> </th>
        <th class="sticky-col first-col"></th>
        <tr class="data-row-container"
          *ngFor="let listOfUsersVwDetails of getTmsTrainingDetailsTableData; let idx = index;">
          <td style="min-width: 80px; text-align: center;">
            <div style="display: flex;">
              <div [ngClass]="listOfUsersVwDetails.searchTrainingChildCheckBoxs ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px;">
                <input  type="checkbox" style="zoom: 1.2;"
                  [checked]="listOfUsersVwDetails.searchTrainingChildCheckBoxs"
                  (change)="searchTrainingChildCheckBoxChecked($event, listOfUsersVwDetails, idx)">
              </div>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersVwDetails.trainingName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.trainingCode }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.version }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.categoryCode }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.type }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.language }}</td>
        </tr>
      </table>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions *ngIf="showUserSearchGrid">
    <button mat-stroked-button class="addButton" (click)="addTrainingNameFunction()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchTrainingFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<!--search-->
<ng-template #searchusers>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchUserFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div  class="form-continer">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email ">User Name</label></div>
        <input class="search-filed-continers uppercase" type="text" [(ngModel)]="searchByUserName">
        <div  class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">First Name</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByFirstName">
        <div id="firstName-val-icon2" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Last Name</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByLastName">
        <div id="lastName-val-icon2" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Email Address</label></div>
        <input class="input-filed-continers" type="email" [(ngModel)]="searchByemailAddress">
      </div>
      <div class="col-md-3">
        <div><label for="email">Designation</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDesignationCode"
          (closed)="designationSearchText=''" (click)="focusSearch('focus-title-search')"
          (keydown.enter)="focusSearch('focus-title-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="designationSearchText" matInput
            placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onDesignationSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of designationCodeDropdown | assessmentSearch : designationSearchText;"
            (onSelectionChange)="onDesignationSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email">Department</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCode"
          (closed)="departmentSearchText=''" (click)="focusSearch('focus-title-search')"
          (keydown.enter)="focusSearch('focus-title-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="departmentSearchText" matInput
            placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onDepartmentSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of departmentCodeDropdown | assessmentSearch : departmentSearchText;"
            (onSelectionChange)="onDepartmentSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row">
      <div class="search-button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="searchButton" (click)="searchUserGridDataFunction()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetSearchUserGridDataFunction()">
          <i class="fa fa-repeat"></i> Reset
        </button>
      </div>
    </div>
    <div class="table-container" *ngIf="showUserSearchGrid">
      <table class="search-manager-table-container">
        <th style="min-width: 80px; text-align: center;">
          <div style="display: flex;">
            <div>
              <i  class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div style="margin-left: 5px;">
              <input id="selectAllCheckbox" type="checkbox" style="zoom: 1.2;" [(ngModel)]="searchUserParentCheckBox"
                (change)="toggleSelectAll($event)">
            </div>
          </div>
        </th>
        <th> <span>User Name</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>First Name</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Last Name</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>User Full Name</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Designation</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Department</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>EmailAddress</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Contact Number</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Manager Name</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Is Ad User</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Is Factory User</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Is Active</span> <span class="fa-solid fa-filter"></span> </th>
        <th class="sticky-col first-col"></th>
        <tr class="data-row-container"
          *ngFor="let listOfUsersVwDetails of getOneQmsUsersVwDetailsTableData; let idx = index;"
          [class.highlightRow]="listOfUsersVwDetails.searchManagerChildCheckBoxs == true">
          <td style="min-width: 80px; text-align: center;">
            <div style="display: flex;">
              <div [ngClass]="listOfUsersVwDetails.searchManagerChildCheckBoxs ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px;">
                <input  type="checkbox" style="zoom: 1.2;"
                  [checked]="listOfUsersVwDetails.searchManagerChildCheckBoxs"
                  (change)="searchManagerChildCheckBoxChecked($event, listOfUsersVwDetails, idx)">
              </div>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersVwDetails.userName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.firstName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.lastName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.userFullName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.designation }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.department }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.emailAddress }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.contactNumber }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.managerName }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersVwDetails.isAdUser === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersVwDetails.isAdUser === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersVwDetails.isFactoryUser === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersVwDetails.isFactoryUser === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersVwDetails.isActive === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersVwDetails.isActive === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>

        </tr>
      </table>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions *ngIf="showUserSearchGrid">
    <button mat-stroked-button class="addButton" (click)="addUserNameFunction()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchUserFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #searchManager>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchManagerFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div  class="form-continer">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email ">User Name</label></div>
        <input class="search-filed-continers uppercase" type="text" [(ngModel)]="searchByUserName">
        <div  class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">First Name</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByFirstName">
        <div id="firstName-val-icon1" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Last Name</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByLastName">
        <div id="lastName-val-icon1" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Email Address</label></div>
        <input class="input-filed-continers" type="email" [(ngModel)]="searchByemailAddress">
      </div>
      <div class="col-md-3">
        <div><label for="email">Designation</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDesignationCode"
          (closed)="designationSearchText=''" (click)="focusSearch('focus-title-search')"
          (keydown.enter)="focusSearch('focus-title-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="designationSearchText" matInput
            placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onDesignationSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of designationCodeDropdown | assessmentSearch : designationSearchText;"
            (onSelectionChange)="onDesignationSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email">Department</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCode"
          (closed)="departmentSearchText=''" (click)="focusSearch('focus-title-search')"
          (keydown.enter)="focusSearch('focus-title-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="departmentSearchText" matInput
            placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onDepartmentSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of departmentCodeDropdown | assessmentSearch : departmentSearchText;"
            (onSelectionChange)="onDepartmentSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row">
      <div class="search-button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="searchButton" (click)="searchUserGridDataFunction()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetSearchUserGridDataFunction()">
          <i class="fa fa-repeat"></i> Reset
        </button>
      </div>
    </div>
    <div class="table-container" *ngIf="showUserSearchGrid">
      <table class="search-manager-table-container">
        <th style="min-width: 80px; text-align: center;">
          <div style="display: flex;">
            <div>
              <i  class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div style="margin-left: 5px;"></div>
          </div>
        </th>
        <th> <span>User Name</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>First Name</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Last Name</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>User Full Name</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Designation</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Department</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>EmailAddress</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Contact Number</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Manager Name</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Is Ad User</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Is Factory User</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Is Active</span> <span class="fa-solid fa-filter"></span> </th>
        <th class="sticky-col first-col"></th>
        <tr class="data-row-container"
          *ngFor="let listOfUsersVwDetails of getOneQmsUsersVwDetailsTableData; let idx = index;"
          [class.highlightRow]="listOfUsersVwDetails.searchManagerChildCheckBox == true">
          <td style="min-width: 80px; text-align: center;">
            <div style="display: flex;">
              <div [ngClass]="listOfUsersVwDetails.searchManagerChildCheckBox ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px;">
                <input  type="checkbox" style="zoom: 1.2;"
                  [checked]="listOfUsersVwDetails.searchManagerChildCheckBox"
                  (change)="searchManagerChildCheckBoxCheckedForRMVSUser($event, listOfUsersVwDetails, idx)">
              </div>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersVwDetails.userName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.firstName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.lastName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.userFullName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.designation }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.department }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.emailAddress }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.contactNumber }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.managerName }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersVwDetails.isAdUser === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersVwDetails.isAdUser === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersVwDetails.isFactoryUser === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersVwDetails.isFactoryUser === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>

          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersVwDetails.isActive === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersVwDetails.isActive === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>

        </tr>
      </table>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions *ngIf="showUserSearchGrid">
    <button mat-stroked-button class="addButton" (click)="addManagerNameFunction()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchManagerFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #searchModuleID>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchModuleIDFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div  class="form-continer">
    <table class="search-manager-table-container">
      <th style="min-width: 80px; text-align: center;">
        <div style="display: flex;">
          <div>
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <div style="margin-left: 5px;">
          </div>
        </div>
      </th>
      <th>
        <span>Task Id</span> <span class="fa-solid fa-filter"></span>
        <input type="text" class="form-control" placeholder="Search" (input)="applyFilter10('taskId', $event)" />
      </th>
      <th>
        <span>Task Details</span> <span class="fa-solid fa-filter"></span>
        <input type="text" class="form-control" placeholder="Search" (input)="applyFilter10('taskDetails', $event)" />
      </th>
      <tr class="data-row-container" *ngFor="let listOfUsersVwDetails of getTaskDetailsObj1; let idx = index;"
        [class.highlightRow]="listOfUsersVwDetails.searchManagerChildCheckBoxs == true">

        <td style="min-width: 80px; text-align: center;">
          <div style="display: flex;">
            <div [ngClass]="listOfUsersVwDetails.searchManagerChildCheckBoxs ?'static_icon':'hover-menu-icons'">
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div style="margin-left: 5px;">
              <input  type="checkbox" style="zoom: 1.2;"
                [checked]="listOfUsersVwDetails.searchManagerChildCheckBoxs"
                (change)="searchTaskVwChildCheckBoxChecked($event, listOfUsersVwDetails, idx)">
            </div>
          </div>
        </td>
        <td class="row-data">{{ listOfUsersVwDetails.taskId }}</td>
        <td class="row-data">{{ listOfUsersVwDetails.taskDetails }}</td>
      </tr>
    </table>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="addTaskVwGridDataFunction()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchModuleIDFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<!--dynamic popup-->
<ng-template #reportPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopupFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">More Activity Report</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopupFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #searchFoldersPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSeachFoldersFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="form-continer">
    <app-folder-stucture [data]="'GROUPFOLDER'"
      (valueChange)="changeInFolderStructureChild($event)"></app-folder-stucture>

    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="addFolderFunction()">
        <i class="fas fa-check"></i> Add
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelSeachFoldersFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<!--Excell & pdf -->
<ng-template #excelPdfPopup>
  <div class="page-loading-shade" *ngIf="appService.isProcessingRep">
    <app-custom-spinner *ngIf="appService.isProcessingRep"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;" class="align-center">
    <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{ popupDataTitle.title }}
      ?</label>
  </div>
  <div style="margin: 15px 15px;" class="align-center" *ngIf="!isForExcel">
    <label for="email" style="font-size: .7rem; font-weight: bold;">
      <span *ngIf="!manuallyPicked">This report will include the first 10 columns by default</span>
      <span *ngIf="manuallyPicked && maxCountReached">
        We recommend selecting a maximum of 10 columns for a cleaner and more readable PDF
      </span>
    </label>
  </div>
  <div class="row " *ngIf="!isForExcel" style="margin:10px 10px 7% 10px;">
    <div class="col-md-12" *ngIf="selectedColumns.length">
      <div><label for="email">Selected Column(s)</label></div>
      <textarea id="selectedValuesTextarea" class="input-filed-textarea" style="margin-top: 8px; cursor: not-allowed;"
        rows="4" cols="50" [disabled]="true" [(ngModel)]="selectedColumnsAsString"></textarea>
    </div>
    <div class="row" [ngClass]="selectedColumns.length ? 'mt-3' : '' ">
      <div class="col-md-6">
        <label for="radio">PDF Page Size</label>
        <mat-radio-group [(ngModel)]="excelPdf.pdfPageSize">
          <mat-radio-button *ngFor="let data of pdfPageSizes"
            [value]="data.codelistCode">{{data.codelistName}}</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="col-md-6" style="margin-top: 1.5%;">
        <label for="toggle">Pick Columns Manually?</label>&nbsp;
        <mat-slide-toggle color="primary" (change)="onCheckboxChange($event)" [(ngModel)]="manuallyPicked" id="toggle">
          <ng-container *ngIf="manuallyPicked; else no">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #no>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row mt-3" *ngIf="manuallyPicked">
      <div class="col-md-12">
        <div><label for="email">Select Column(s)</label><span class="mandatory-symbol">*</span></div>
        <mat-select matInput multiple placeholder="Select" #pdf id="execl-pdf" [(ngModel)]="selectedColumns"
          (closed)="pdfSearchText=''" (click)="focusSearch('focus-department-search')"
          (keydown.enter)="focusSearch('focus-department-search')">
          <input type="search" id="focus-department-search" class="dropdownsearchstyle" [(ngModel)]="pdfSearchText"
            matInput placeholder="search">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="pdfSelection" (change)="toggleAllSelection('pdf')"> Select All</mat-checkbox>
          </div>
          <mat-option *ngFor="let item of excelPdf.dropDown | multiAssessmentSearchPipe : pdfSearchText"
            [value]="item.valueExp" (onSelectionChange)="onColumnSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter" (closed)="pdfDetailSearchText=''"
          (click)="focusSearch('focus-Logo-search')" (keydown.enter)="focusSearch('focus-Logo-search')">
          <input type="search" id="focus-footer-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
            matInput placeholder="search">
          <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
            (onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label  for="email">Is Save Report?</label>
      </div>
      <div class="col-sm-8">
        <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
          <ng-container *ngIf="isSaveReport; else noisSaveReport">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #noisSaveReport>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row justify-content-md-center" *ngIf="isSaveReport">
      <div class="col-sm-4">
        <label  for="email">Report Name</label>
      </div>
      <div class="col-sm-8">
        <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
      </div>
    </div>

  </div>
  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
    <button *ngIf="isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Excel')">
      <i class="fa fa-file-excel-o"></i> Generate
    </button>
    <button *ngIf="!isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Pdf')">
      <i class="fa fa-file-pdf-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<!-- search instructor training -->
<ng-template #searchInstructorTraining>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchInstructorTrainingFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Search Instructor Training</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div  class="form-continer">
    <div class="row">
      <label for=" " style="color:red;" *ngIf="noUserAlert">Please select training</label>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div><label for="email">Training Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Training Name"
          [(ngModel)]="searchByInstructorTrainingName">
      </div>
      <div class="col-md-3">
        <div><label for="email">Version</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Version" [(ngModel)]="searchByVersion">
      </div>
      <div class="col-md-3">
        <div><label for="email">Trainer Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Trainer Name"
          [(ngModel)]="searchByTrainerName">
      </div>
      <div class="col-md-3">
        <div><label for="email">Training Mode</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Training Mode"
          [(ngModel)]="searchByTrainingMode">
      </div>
      <div class="col-md-3">
        <div><label for="email">Status</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Status" [(ngModel)]="searchByStatus">
      </div>
    </div>
    <div class="row">
      <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="addButton" (click)="searchInstructorTrainingGridDataFunction()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetSearchInstructorTrainingGridDataFunction()">
          <i class="fa fa-repeat"></i> Reset
        </button>
      </div>
    </div>
    <div class="table-container" *ngIf="showInstructorTrainingSearchGrid">
      <table class="search-manager-table-container">
        <th style="min-width: 80px; text-align: center;">
         
        </th>
        <th> <span>Training Name</span> <span class="fa-solid fa-filter"></span>
        </th>
        <th> <span>Version</span> <span class="fa-solid fa-filter"></span>
        </th>
        <th> <span>Trainer Name</span> <span class="fa-solid fa-filter"></span>
        </th>
        <th> <span>Training Mode</span> <span class="fa-solid fa-filter"></span>
        </th>
        <th> <span>Status</span> <span class="fa-solid fa-filter"></span>
        </th>
        <th class="sticky-col first-col"></th>
        <tr class="data-row-container"
          *ngFor="let listOfUsersVwDetails of getTmsInstructorTrainingDetailsTableData; let idx = index;">
          <td style="min-width: 80px; text-align: center;">
            <div style="display: flex;">
              <div [ngClass]="listOfUsersVwDetails.searchTrainingChildCheckBoxs ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px;">
                <input  type="checkbox" style="zoom: 1.2;"
                  [checked]="listOfUsersVwDetails.searchTrainingChildCheckBoxs"
                  (change)="searchInstructorTrainingChildCheckBoxChecked($event, listOfUsersVwDetails, idx)">
              </div>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersVwDetails.trainingName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.version }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.trainerName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.trainingMode }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.status }}</td>
        </tr>
      </table>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions *ngIf="showInstructorTrainingSearchGrid">
    <button mat-stroked-button class="addButton" (click)="addInstructorTrainingNameFunction()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchInstructorTrainingFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<app-editor #clobViewPopup></app-editor>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmitted()"></app-grid-reorder>